module.exports = __webpack_public_path__ + "static/media/flowers_18.45dafdf0.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_18.csv
// module id = 757
// module chunks = 0